import React, { useContext } from "react";
import { AccountReadinessContext } from './accountReadinessPresentation';
import { useAccountReadinessViewModel } from './useAccountReadinessViewModel';

export const AccountReadinessProvider = ({ children }: { children: React.ReactNode }) => {
  const { refresh, current } = useAccountReadinessViewModel();

  return <AccountReadinessContext.Provider value={{ ...current, refresh }}>{children}</AccountReadinessContext.Provider>;
};

export const useAccountReadiness = () => {
  const context = useContext(AccountReadinessContext);
  if (!context) throw new Error("AccountReadinessProvider is required.");
  return context;
};
